var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{attrs:{"cols":"12"}},[_c('p',{staticClass:"headTitle"},[_vm._v(_vm._s(_vm.areaTitle))]),_c('p',{staticClass:"headSubTitle"},[_vm._v(_vm._s(_vm.areaSubTitle))])])}
var staticRenderFns = []

export { render, staticRenderFns }